<template>
    <Wrapper>
        <div class="row">
            <div class="col-xl-9 col-lg-10 my-2 text-center mx-auto">
                <div class="row no-gutters my-3">
                    <div class="col-md-4 pr-md-2 pr-0 ml-auto">
                        <div class="list-group text-center my-3">
                            <div class="list-group-item text-primary bg-dark">
                                <h4 class="text-center my-1">Basic</h4>
                            </div>
                            <div class="list-group-item text-uppercase font-weight-bold">
                                Free
                            </div>
                            <a href="# " class="list-group-item">
                                100 GB HDD Storage
                            </a>
                            <a href="# " class="list-group-item">
                                Web Server
                            </a>
                            <a href="# " class="list-group-item">
                                DNS Hosting
                            </a>
                            <a href="# " class="list-group-item">
                                Mail Server
                            </a>
                            <div class="list-group-item">
                                <button class="btn btn-secondary btn-lg text-truncate">Sign-up</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-overlay">
                        <div class="list-group text-center shadow-sm bg-alt">
                            <div class="list-group-item text-primary bg-dark">
                                <h4 class="text-center my-1">Standard<br/></h4>
                            </div>
                            <div class="list-group-item text-uppercase font-weight-bold">
                                $99/mo.
                            </div>
                            <a href="# " class="list-group-item">
                                1 TB HDD Storage
                            </a>
                            <a href="# " class="list-group-item">
                                <span class="float-right"><i class="ion-ios-star-outline fa fa-star-o"></i></span> Database Option
                            </a>
                            <a href="# " class="list-group-item">
                                Web Server
                            </a>
                            <a href="# " class="list-group-item">
                                DNS Hosting
                            </a>
                            <a href="# " class="list-group-item">
                                24/7 Monitoring
                            </a>
                            <div class="list-group-item bg-inverse">
                                <button class="btn btn-secondary btn-lg text-truncate">Buy Now</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 pl-md-2 pl-0 mr-auto">
                        <div class="list-group text-center my-3">
                            <div class="list-group-item text-primary bg-dark">
                                <h4 class="text-center my-1">Managed</h4>
                            </div>
                            <div class="list-group-item text-uppercase font-weight-bold">
                                Contact Us
                            </div>
                            <a href="# " class="list-group-item">
                                Upto 10 TB HDD Storage
                            </a>
                            <a href="# " class="list-group-item">
                                Consultation
                            </a>
                            <a href="# " class="list-group-item">
                                Custom Servers
                            </a>
                            <a href="# " class="list-group-item">
                                24/7 Support
                            </a>
                            <div class="list-group-item">
                                <button class="btn btn-secondary btn-lg text-truncate">Contact Us</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-md-12 px-md-5 px-1">
                        <div class="table-responsive">
                        <table class="table table-striped table-hover">
                          <thead class="thead-inverse">
                            <tr>
                                <th class="w-25 border-0"></th>
                                <th class="border-0">Basic</th>
                                <th class="border-0">Standard</th>
                                <th class="border-0">Premium</th>
                                <th class="border-0">Managed</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="w-25 option">HDD Storage</td>
                              <td class="">500 MB</td>
                              <td class="">1 GB</td>
                              <td class="">2 GB</td>
                              <td class="">upto 5 TB</td>
                            </tr>
                            <tr>
                              <td class="option">Web Server</td>
                              <td><i class="fa fa-check"></i></td>
                              <td><i class="fa fa-check"></i></td>
                              <td><i class="fa fa-check"></i></td>
                              <td><i class="fa fa-check"></i></td>
                            </tr>
                            <tr>
                              <td class="option">Mail Server</td>
                              <td>-</td>
                              <td><i class="fa fa-check"></i></td>
                              <td><i class="fa fa-check"></i></td>
                              <td><i class="fa fa-check"></i></td>
                            </tr>
                            <tr>
                              <td class="option">DNS</td>
                              <td>-</td>
                              <td>-</td>
                              <td><i class="fa fa-check"></i></td>
                              <td><i class="fa fa-check"></i></td>
                            </tr>
                            <tr>
                              <td class="option">Database</td>
                              <td>-</td>
                              <td>optional</td>
                              <td><i class="fa fa-check"></i></td>
                              <td><i class="fa fa-check"></i></td>
                            </tr>
                            <tr>
                              <td class="option">Backups</td>
                              <td>-</td>
                              <td>-</td>
                              <td><i class="fa fa-check"></i></td>
                              <td><i class="fa fa-check"></i></td>
                            </tr>
                            <tr>
                              <td class="option">Tech Support</td>
                              <td>None</td>
                              <td>$50/incident</td>
                              <td>$35/incident</td>
                              <td>24/7 included</td>
                            </tr>
                            <tr>
                              <td class="option">Custom Servers</td>
                              <td>-</td>
                              <td>-</td>
                              <td><i class="fa fa-check"></i></td>
                              <td><i class="fa fa-check"></i></td>
                            </tr>
                            <tr class="text-uppercase font-weight-bold">
                                <td></td>
                                <td>Free</td>
                                <td>$99/mo</td>
                                <td>$179/mo</td>
                                <td><a href="# ">Contact us</a></td>
                            </tr>
                          </tbody>
                          <tfoot class="thead-inverse">
                            <tr>
                                <th class="w-25"></th>
                                <th class=""><button class="btn btn-primary">Sign-up</button></th>
                                <th class=""><button class="btn btn-primary">Buy Now</button></th>
                                <th class=""><button class="btn btn-primary">Buy Now</button></th>
                                <th class=""></th>
                            </tr>
                          </tfoot>
                        </table>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </Wrapper>
</template>
<script>
import { Wrapper } from '../components';

export default {
    components: {
        Wrapper
    }
}
</script>
